<template>
  <el-col :span="12" :offset="6" class="enrollment-complete-card">
    <client-card :name="client.firstName + ' ' + client.lastName" title="Primary" :ssn="client.ssn" :state-id="client.stateId">
      <el-row :gutter="18">
        <el-col :span="24" class="align-center pb-3">
          <h2 v-if="isEnrolled">The client is now <span class="green">ENROLLED</span> in the Early Bird Program!</h2>
          <h2 v-if="!isEnrolled && !ebOptout">The client <span class="red">DOES NOT QUALIFY</span> for the Early Bird Program.</h2>
          <h2 v-if="!isEnrolled && ebOptout">The client <span class="red">ELECTED TO OPT-OUT</span> of the Early Bird Program.</h2>
          <early-bird-enrollment-pdf-button type="primary" :disabled="!canViewEnrollmentPackage">View Early Bird Program Packet</early-bird-enrollment-pdf-button>
          <raf-slips-pdf-button :client-id="client.id">View RAF Slips</raf-slips-pdf-button>
          <p v-if="!canViewEnrollmentPackage">NOTE: {{ disabledReason }}</p>
        </el-col>
      </el-row>
    </client-card>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import ClientCard from '@/components/widgets/ClientCard.vue';
import { STATE } from '@/enum/EarlyBirdApplicationStates';
import RafSlipsPdfButton from '@/components/PDFButton/RAFSlips';
import EarlyBirdEnrollmentPdfButton from '@/components/PDFButton/EarlyBirdEnrollment';

export default {
  components: {
    ClientCard,
    RafSlipsPdfButton,
    EarlyBirdEnrollmentPdfButton,
  },
  computed: {
    ...mapGetters('Client', [
      'client',
      'ebApplicationState',
      'ebEnrollment',
      'ebOptout',
    ]),
    ...mapGetters('User', [
      'isAdmin',
    ]),
    statusText() {
      if (this.isEnrolled) {
        return 'ENROLLED';
      } if (this.ebApplicationState === STATE.DOES_NOT_QUALIFY) {
        return 'DOES NOT QUALIFY for';
      }
      return '';
    },
    isEnrolled() {
      return this.ebApplicationState === STATE.ENROLLED;
    },
    canViewEnrollmentPackage() {
      const lessThanHourSinceEnrollment = this.ebEnrollment ? moment(this.ebEnrollment.dateAdded).add(60, 'minutes').isAfter(/** now */) : false;
      return this.isAdmin || lessThanHourSinceEnrollment || !this.isEnrolled;
    },
    disabledReason() {
      return 'Only an ADMIN can review the Enrollment Packet after the application is complete.';
    },
  },
};

</script>

<style lang="scss">

.enrollment-complete-card {
  .green {
    color: #67c23a;
  }
  .red {
    color: #f56c6c;
  }
}

</style>
